import {
  Environment,
  IEnvironment,
  INetwork,
  RecordSource,
  Store,
} from "relay-runtime";
import { RecordMap } from "relay-runtime/lib/store/RelayStoreTypes";

import { DEPLOY_ENV } from "@framework/config";
import { log } from "@framework/relay/logger";

export default function createEnvironment(
  network: INetwork,
  records?: RecordMap,
): IEnvironment {
  const recordSource = new RecordSource(records);
  const store = new Store(recordSource);

  return new Environment({
    store,
    network,
    // Tell Relay that we are using this on the server.
    isServer: typeof window === "undefined",
    relayFieldLogger: (event) => {
      let message = "Relay Error";
      if ("error" in event && event.error.message) {
        message = `${message}: ${event.error.message}`;
      }
      // Log server side.
      if (typeof window === "undefined") {
        log.error(event, message);
      }
      // For non-production deploys, we can additionally log to the browser console for easier debugging.
      else if (!DEPLOY_ENV.includes("production")) {
        console.error(message, event);
      }
    },
  });
}
